import { render, staticRenderFns } from "./AppUserMenu.vue?vue&type=template&id=16308696&scoped=true"
import script from "./AppUserMenu.vue?vue&type=script&lang=js"
export * from "./AppUserMenu.vue?vue&type=script&lang=js"
import style0 from "./AppUserMenu.vue?vue&type=style&index=0&id=16308696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16308696",
  null
  
)

export default component.exports